module.exports = __webpack_public_path__ + "img/sleeping_in_the_great_hall.115e5aa7.jpg";